export default {
  name: 'DraftProfilePopup',
  data() {
    return {
      isClosed: false,
      username: ''
    };
  },
  computed: {
    isVisible() {
      // Show only if not closed and username starts with [DRAFF]
      return !this.isClosed && this.username && this.username.startsWith('[DRAFF]');
    }
  },
  watch: {
    '$route'() {
      // Re-evaluate on route change, reset isClosed to false
      this.isClosed = false;
      this.checkUser();
    }
  },
  mounted() {
    this.checkUser();
    window.addEventListener('storage', this.checkUser);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.checkUser);
  },
  methods: {
    checkUser() {
      const accountStr = localStorage.getItem('current-account');
      if (accountStr) {
        try {
          const account = JSON.parse(accountStr);
          this.username = account.username || '';
        } catch (e) {
          this.username = '';
        }
      } else {
        this.username = '';
      }
    },
    closePopup() {
      this.isClosed = true;
    },
    goToUpdate() {
      this.isClosed = true;
      this.$router.push('/user-edit');
    }
  }
};
